<template>
  <div
    class="diet row"
    :class="{ 'diet--selected': diet.selected }"
    @mouseenter="emit('hover', `diet-${diet.id}`)"
    @mouseleave="emit('hover', '')"
  >
    <div class="column">
      <BaseCheckbox :model-value="diet.selected" @update:model-value="emit('select')" />
    </div>
    <div class="column diet__name">
      <router-link
        :to="{ name: 'DietDetail', params: { dietType, dietId: diet.id } }"
        draggable="true"
        @dragstart="emit('dragstart', $event)"
        @dragend="emit('dragend')"
      >
        {{ diet.name }}
      </router-link>
    </div>
    <div class="column diet__calories">{{ diet.calories }}</div>
    <div v-if="hovered" class="row__actions">
      <div class="diet__actions">
        <div class="copy-diet-wrapper">
          <Tooltip placement="top-end">
            <template #trigger>
              <IconButton name="filter_none" icon-size="18" @click.stop="emit('show-copy')" />
            </template>
            Skopiuj szablon do Twojej grupy
          </Tooltip>
          <DietListCopyMoveMenu
            v-if="copyMenuVisible"
            class="copy-diet-menu"
            title="Skopiuj do:"
            :groups="groups"
            :hide-add-group="true"
            @select-group="emit('copy', $event)"
            @close="emit('close-copy')"
          />
        </div>
        <Tooltip placement="top-end">
          <template #trigger>
            <IconButton name="person_add" @click.stop="emit('copy-patient')" />
          </template>
          Skopiuj szablon do pacjenta
        </Tooltip>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import BaseCheckbox from '@/components/BaseCheckbox.vue'
  import DietListCopyMoveMenu from '@/components/diets/DietListCopyMoveMenu.vue'
  import { IconButton } from '@/components/IconButton'
  import { Tooltip } from '@/components/ui'

  import type { DietType, UserGroup } from '@/store/types'

  import type { SystemDietListItem } from '../../types'

  defineProps<{
    copyMenuVisible: boolean
    diet: SystemDietListItem
    dietType: DietType
    groups: UserGroup[]
    hovered: boolean
  }>()
  const emit = defineEmits<{
    'close-copy': []
    copy: [groupId: number]
    'copy-patient': []
    dragend: []
    dragstart: [event: DragEvent]
    hover: [key: string]
    select: []
    'show-copy': []
  }>()
</script>
